function filterData(data) {
  const filteredObj = {};
  filteredObj.temp = data.observation.metric.temp || '';
  filteredObj.iconCode = data.observation.icon_code || '';
  filteredObj.skyCover = data.observation.phrase_32char || '';
  filteredObj.isDay = data.observation.day_ind === 'D';
  return filteredObj;
}
function filterLocation(data) {
  let postalID = '';
  const newArry =
    Array.isArray(data.location.postalCode) &&
    data.location.postalCode.length > 0 &&
    data.location.postalCode.filter(item => item);
  postalID = Array.isArray(newArry) && newArry.length > 0 && newArry[0];
  return postalID;
}

export default { filterData, filterLocation };
